import { Menus, MenuActionTypes } from '../../actions/Administracion/menus.actions';
import { menuInterface, datosPersonalesInterface } from '../../../Model/Administracion/menu.Interface';

export interface State {
    menus: any[];
    datosPersonales: datosPersonalesInterface;
}

export const initialState: State = {
    menus: [],
    datosPersonales: {nombre: ''}
}

export function reducer(state = initialState, action: Menus): State {
    switch (action.type) {
        case MenuActionTypes.GetMenus: {
            // localStorage.setItem('menus', JSON.stringify(action.payload));
            return { ...state, menus: [...action.payload] };
        }
       
        
        default:
            return state;
    }
}